import withFeatureBranch from '@wix/da-react-context/pkg/flags/withFeatureBranch';
import Branched from '../DesktopArtStage.multi_file_deviation';
import NonBranched from './DesktopArtStage';
export default withFeatureBranch({
    multi_file_deviation: Branched
})(NonBranched);

//# sourceMappingURL=index.js.map